import {FC} from "react";
import {Form, Formik, FormikConfig, FormikValues, useFormikContext} from "formik";
import {Button, IButtonProps} from "@web2/button";
import {Checkbox, ICheckboxProps} from "@web2/checkbox";
import {IInputProps, Input, ITextareaProps, Textarea} from "@web2/input";

import {getFormikFieldProps} from "./get_formik_field_props";
import {OnChangeHandlingComponent} from "./OnChangeHandlingComponent";

interface IProps<TValues> extends FormikConfig<TValues> {
    onChange?: () => void;
}

export const FormikForm = <T extends FormikValues>(props: IProps<T>) => {
    const {children, ...formikProps} = props;

    return (
        <Formik {...formikProps}>
            {(formProps) => {
                return (
                    <>
                        {props.onChange && <OnChangeHandlingComponent onChange={props.onChange} />}
                        <Form onSubmit={formProps.handleSubmit}>{typeof children === "function" ? children(formProps) : children}</Form>
                    </>
                );
            }}
        </Formik>
    );
};

export type IFieldProps<StandardFieldType> = Omit<StandardFieldType, "onChange" | "name" | "onAfterChange" | "value" | "error" | "checked"> & {
    name: string;
};
const FormikInput = <TValues extends Record<string, unknown>>(props: IFieldProps<IInputProps<string>>) => {
    const formikProps = useFormikContext<TValues>();
    return <Input {...props} {...getFormikFieldProps<TValues>(formikProps, props.name)} />;
};
FormikForm.Input = FormikInput;
//

const FormikTextarea = <TValues extends Record<string, unknown>>(props: IFieldProps<ITextareaProps<string>>) => {
    const formikProps = useFormikContext<TValues>();
    return <Textarea {...props} {...getFormikFieldProps<TValues>(formikProps, props.name)} />;
};
FormikForm.Textarea = FormikTextarea;
//

const FormikCheckbox = <TValues extends Record<string, unknown>>(props: IFieldProps<ICheckboxProps>) => {
    const formikProps = useFormikContext<TValues>();
    return <Checkbox {...props} {...getFormikFieldProps<TValues>(formikProps, props.name)} />;
};
FormikForm.Checkbox = FormikCheckbox;
//

const FormikButton: FC<IButtonProps> = (props) => {
    const formikProps = useFormikContext();
    return (
        <Button {...props} isLoading={formikProps.isSubmitting}>
            {props.children}
        </Button>
    );
};
FormikForm.Button = FormikButton;
